"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var urls_1 = __importDefault(require("../../app/urls"));
var store_1 = require("../../app/store");
var translate_1 = __importDefault(require("../../app/localization/translate"));
exports.useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return ({
        root: (_a = {
                position: 'relative',
                zIndex: theme.zIndex.drawer,
                marginTop: theme.spacing(4),
                borderTop: theme.youwell.borders.dim,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                background: theme.palette.background.default,
                padding: theme.spacing(2)
            },
            _a[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(8),
                padding: theme.spacing(4, 1),
            },
            _a),
        footerLink: {
            margin: theme.spacing(0.5, 4),
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    });
});
var Footer = function () {
    var translate = (0, translate_1.default)();
    var classes = (0, exports.useStyles)();
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    if (!(clientConfig.z_PrivacyPolicyTaskId || clientConfig.z_UUReportTaskId)) {
        return null;
    }
    return (React.createElement("div", { className: classes.root },
        clientConfig.z_PrivacyPolicyTaskId && (React.createElement(react_router_dom_1.Link, { to: "".concat(urls_1.default.inside.pages.singlepage, "/").concat(clientConfig.z_PrivacyPolicyTaskId), className: classes.footerLink },
            React.createElement(core_1.Typography, { color: "primary" }, translate('footer.privacyPolicy')))),
        clientConfig.z_UUReportTaskId && (React.createElement(React.Fragment, null, clientConfig.z_UUReportTaskId.startsWith('http') ? (React.createElement(core_1.Link, { href: clientConfig.z_UUReportTaskId, className: classes.footerLink, target: "_blank" },
            React.createElement(core_1.Typography, { color: "primary" }, translate('footer.uuReport')))) : (React.createElement(react_router_dom_1.Link, { to: "".concat(urls_1.default.inside.pages.singlepage, "/").concat(clientConfig.z_UUReportTaskId), className: classes.footerLink },
            React.createElement(core_1.Typography, { color: "primary" }, translate('footer.uuReport'))))))));
};
exports.default = Footer;
